import { useParams } from "react-router-dom";

import { type ResourceContainer, ResourceKind } from "../../gql-generated/types";

import { useSearchParams } from "./useSearchParams";

import { LensFoldersSearchParams, useOrgChildResources } from ".";

export interface UseSelectedLensFolderResult {
    lensFolder: ResourceContainer | null;
    loading: boolean;
}

export const useSelectedLensFolder = (): UseSelectedLensFolderResult => {
    const { lensFolderId } = useParams<{ lensFolderId?: string }>();
    const searchParams = useSearchParams();
    const searchParamsLensFolder = new URLSearchParams(window.location.search);

    const id =
        lensFolderId ??
        searchParams.get(LensFoldersSearchParams.LensFolder) ??
        searchParamsLensFolder.get(LensFoldersSearchParams.LensFolder);

    const { resourceContainers, loading } = useOrgChildResources({
        kind: ResourceKind.LensSpaces,
    });

    const lensFolder = resourceContainers.find((lf) => lf.id === id);

    return {
        lensFolder: lensFolder ?? null,
        loading,
    };
};
